import React from "react";
import { Outlet, useLocation } from "react-router-dom";

const MainLayout = () => {
    const location = useLocation();
    return (
        <div className="min-h-screen bg-gray-50" style={{ textAlign: "left" }}>
            {/* {location.pathname === "/" ? <MainHeader /> : <SharedHeader />} */}
            <main>
                <Outlet />
            </main>
        </div>
    );
};

export default MainLayout;